<div class="slider-track-wrapper" #sliderOuter data-testid="ev-slider-track">
  <div class="slider-track" [style.--fill-value]="valueInPercent">
    <div class="slider-track-inner" data-testid="ev-slider-track-inner">
      <div class="slider-thumb" data-testid="ev-slider-thumb" [ngStyle]="{'left': valueInPercent + '%'}"></div>
    </div>
  </div>
</div>